import styled from 'styled-components';
import {Link} from 'react-router-dom';

export const PrimaryButton = styled.button`
  background: ${props => (props?.disabled ?'#F9F9F9' : 'linear-gradient(93.66deg, #53b2fe 0%, #065af3 100%)')};
  box-shadow: 0px 1px 7px rgba(0, 0, 0, 0.21);
  border-radius: 4px;
  color:${props => (props?.disabled? '':'#fff')};
  font-weight: 900;
  font-size: 16px;
  line-height: 24px;
  padding: ${props => (props.padding ? props.padding : '10px 16px')};
  border: none;
  cursor:${props => (props?.disabled? '':'pointer')};
`;

export const PrimaryButtonOutlined = styled(PrimaryButton)`
  background: #ffffff;
  border: 1px solid #008cff;
  color: #008cff;
`;

export const SecondaryButton = styled.button`
  margin-right: 32px;
  font-weight: 900;
  line-height: 24px;
  color: #008cff;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  border: none;
  cursor: pointer;
`;

export const DownloadButton = styled.button`
  border-radius: 4px;
  border: none;
  color: #909090;
  font-weight: 900;
  font-size: 16px;
  cursor: pointer;
  padding: 10px 16px;
  background-color: ${props => (props.isActive ? '#008CFF' : '#C2C2C2')};
  color: ${props => (props.isActive ? '#fff' : '#909090')};
  box-shadow: ${props => (props.isActive ? '0px 1px 7px rgba(0, 0, 0, 0.21)' : '')};
`;
